interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const getSchema = (): Record<string, unknown> => {
    const base = { '@context': 'https://schema.org' };

    switch (type) {
      case 'Organization':
        return {
          ...base,
          '@type': 'Organization',
          name: '琴韵阁',
          url: 'https://www.liujiaoqin.com',
          description: '国内领先的六角琴学习与选购平台，专注于六角琴教育推广和文化传播。',
          email: 'contact@qinyunge.com',
          telephone: '400-888-6666',
          address: {
            '@type': 'PostalAddress',
            addressLocality: '北京',
            addressRegion: '朝阳区',
            streetAddress: '建国路88号音乐大厦12层',
            addressCountry: 'CN',
          },
          sameAs: [
            'https://www.liujiaoqin.com',
          ],
        };
      case 'WebSite':
        return {
          ...base,
          '@type': 'WebSite',
          name: '琴韵阁 - 六角琴专业指南',
          url: 'https://www.liujiaoqin.com',
          description: '六角琴是一种独特的六边形弦鸣乐器，本网站为您详细介绍六角琴的历史起源、演奏技巧、音色特点、型号选择及购买建议。',
          inLanguage: 'zh-CN',
        };
      case 'WebPage':
        return {
          ...base,
          '@type': 'WebPage',
          name: data?.name || '六角琴专业指南',
          description: data?.description || '六角琴专业演奏与入门选购完全指南',
          url: data?.url || 'https://www.liujiaoqin.com',
          inLanguage: 'zh-CN',
          isPartOf: {
            '@type': 'WebSite',
            name: '琴韵阁 - 六角琴专业指南',
            url: 'https://www.liujiaoqin.com',
          },
          ...data,
        };
      case 'Article':
        return {
          ...base,
          '@type': 'Article',
          headline: data?.headline || '',
          description: data?.description || '',
          author: {
            '@type': 'Person',
            name: data?.author || '琴韵阁',
          },
          datePublished: data?.datePublished || '',
          dateModified: data?.dateModified || data?.datePublished || '',
          publisher: {
            '@type': 'Organization',
            name: '琴韵阁',
          },
          inLanguage: 'zh-CN',
          ...data,
        };
      case 'FAQPage':
        return {
          ...base,
          '@type': 'FAQPage',
          mainEntity: data?.questions || [],
        };
      default:
        return { '@context': 'https://schema.org', '@type': 'WebPage' };
    }
  };

  const schema = getSchema();

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}